import type { UrlEntry, UrlRegion } from '@/types';

export const urls: Record<'blog', Partial<Record<UrlRegion, UrlEntry>>> = {
  blog: {
    de: 'blog',
    es: 'blog',
    fr: 'blog',
    gb: 'blog',
    nl: 'blog',
    pt: 'blog',
    us: 'blog',
    ww: 'blog',
  },
};
